//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  angular.module('curalate').component('contentEmptyState', {
    bindings: {
      message: '@',
      messageBody: '@',
    },
    template: require('@legacy-components/content/content-empty-state.html'),
  });
})();
